import { photoSrc } from '../api';

export function Avatar({ url, name, size = '' }: { url: string | null; name: string; size?: '' | 'sm' | 'lg' }) {
  const src = photoSrc(url);
  if (src) return <img className={`avatar ${size}`} src={src} alt={name} />;
  return <div className={`avatar avatar-placeholder ${size}`}>{name.slice(0, 1).toUpperCase() || '?'}</div>;
}
